import httpClient from './_httpClient';

const END_POINT = '/roles';

const getAllRoles = () => httpClient.get(END_POINT);
const addPermissionToRole =
  (role, permission) => httpClient.post(END_POINT + '/permissions', {role, permission});
const removePermissionFromRole =
  (role, permission) => httpClient.delete(END_POINT + '/permissions', {params: {role, permission}});

export {
  getAllRoles,
  addPermissionToRole,
  removePermissionFromRole
}
